
import { ReactNode } from 'react';
import styled from 'styled-components';
import THEME from '../../../theme';
import Link from '@/components/molecules/Link';
import devices from '@/utilities/devices';

// #region STYLE
const ButtonContainer = styled.div<{
	version: 'whiteOnTransparent' | 'blackOnWhite' | 'redOnWhite' | 'whiteOnRed';
	fontSize?: string;
	margin?: { top?: string; right?: string; bottom?: string; left?: string; }
	marginOnMobile?: { top?: string; right?: string; bottom?: string; left?: string; }
}>`
	align-items: center;
	display: flex;
	justify-content: center;
	margin: ${({ margin }) => `${margin?.top ?? 0} ${margin?.right ?? 0} ${margin?.bottom ?? 0} ${margin?.left ?? 0}`};
	text-align: center;
	user-select: none;
	a {
		border-radius: 40px;
		background-color: ${({ version, theme }) => {
			switch (version) {
				case 'whiteOnTransparent':
					return theme.color.transparent;
				case 'blackOnWhite':
					return theme.color.white;
				case 'redOnWhite':
					return theme.color.white;
				case 'whiteOnRed':
					return theme.color.red;
			}
		}};
		border: 2px solid ${({ version, theme }) => {
			switch (version) {
				case 'whiteOnTransparent':
					return theme.color.white;
				case 'blackOnWhite':
					return theme.color.grey;
				case 'redOnWhite':
					return theme.color.white;
				case 'whiteOnRed':
					return theme.color.red;
			}
		}};
		filter: drop-shadow(${({ version, theme }) => {
			switch (version) {
				case 'whiteOnTransparent':
					return `0rem .2rem .2rem ${theme.color.transparent}`;
				case 'blackOnWhite':
					return `0rem .2rem .2rem rgba(${theme.color.rgbWhite}, .4)`;
				case 'redOnWhite':
					return `0rem .2rem .2rem rgba(${theme.color.rgbWhite}, .4)`;
				case 'whiteOnRed':
					return `0rem .2rem .2rem rgba(${theme.color.rgbRed}, .4)`;
			}
		}});
		color: ${({ version, theme }) => {
			switch (version) {
				case 'whiteOnTransparent':
					return theme.color.white;
				case 'blackOnWhite':
					return theme.color.black;
				case 'redOnWhite':
					return theme.color.red;
				case 'whiteOnRed':
					return theme.color.white;
			}
		}};
		display: inline-block;
		font-size: ${props => props.fontSize};
		font-weight: 700;
		letter-spacing: 1px;
		outline: 0;
		padding: .5rem 1rem;
		text-decoration: none;
		text-transform: uppercase;
		transition: .3s;
		white-space: nowrap;

		:hover {
			background-color: ${props => {
				switch (props.version) {
					case 'whiteOnTransparent':
						return props.theme.color.red;
					case 'blackOnWhite':
						return props.theme.color.greyLight;
					case 'redOnWhite':
						return props.theme.color.red;
					case 'whiteOnRed':
						return props.theme.color.white;
				}
			}};
			border: 2px solid ${props => {
				switch (props.version) {
					case 'whiteOnTransparent':
						return props.theme.color.red;
					case 'blackOnWhite':
						return props.theme.color.grey;
					case 'redOnWhite':
						return props.theme.color.white;
					case 'whiteOnRed':
						return props.theme.color.red;
				}
			}};
			color: ${props => {
				switch (props.version) {
					case 'whiteOnTransparent':
						return props.theme.color.white;
					case 'blackOnWhite':
						return props.theme.color.black;
					case 'redOnWhite':
						return props.theme.color.white;
					case 'whiteOnRed':
						return props.theme.color.red;
				}
			}};
		}

		@media screen and (${devices.mobile}) {
			font-size: ${({ theme }) => theme.fontSize.XSMALL};
			margin: ${({ marginOnMobile }) => `${marginOnMobile?.top ?? 0} ${marginOnMobile?.right ?? 0} ${marginOnMobile?.bottom ?? 0} ${marginOnMobile?.left ?? 0}`};
		}
		@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
			font-size: ${({ theme }) => theme.fontSize.XSMALL};
		}
		@media screen and (${devices.minLaptop}) and (${devices.maxLaptop}) {
			font-size: ${({ theme }) => theme.fontSize.XSMALL};
		}
	}

	@media screen and (${devices.mobile}) {
		display: block;
		margin: ${({ marginOnMobile }) => !(marginOnMobile) && 'auto !important'};
		padding: 1em 0 1.5em;
		text-align: center;
		width: auto;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		display: block;
		margin: auto !important;
		padding: 1em 0 1.7em;
		text-align: center;
		width: 90%;
	}

	svg {
		font-size: 1.1em;
		padding-left: 1em;
	}
`;
// #endregion

interface ButtonProps {
	className?: string;
	children?: ReactNode;
	fontSize?: string;
	gtm_id?: string;
	href: string;
	margin?: { top?: string; right?: string; bottom?: string; left?: string; };
	marginOnMobile?: { top?: string; right?: string; bottom?: string; left?: string; }
	onClick?: () => void;
	openOnNewTab?: boolean;
	text: string;
	version: 'whiteOnTransparent' | 'blackOnWhite' | 'redOnWhite' | 'whiteOnRed';
}

const Button_v2 = ({
	children, className,
	fontSize,
	gtm_id,
	href,
	margin, marginOnMobile,
	onClick, openOnNewTab,
	text,
	version,
}: ButtonProps) => {

	return (
		<ButtonContainer
			className={className}
			fontSize={fontSize ? fontSize : THEME.fontSize.XSMALL}
			id={gtm_id}
			margin={margin}
			marginOnMobile={marginOnMobile}
			onClick={onClick}
			version={version}
		>
			<Link
				href={href}
				openOnNewTab={openOnNewTab ?? false}
				text={text}
			>
				{children}
			</Link>
		</ButtonContainer>
	);
};

export default Button_v2;
